import { frontendURL } from 'dashboard/helper/URLHelper.js';

import CampaignsPageRouteView from './pages/CampaignsPageRouteView.vue';
import AllCampaignsPage from './pages/AllCampaignsPage.vue';
import CampaignBuilderPage from 'dashboard/components-next/Campaigns/Pages/Builder/CampaignBuilderPage.vue';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsPageRouteView,
      children: [
        {
          path: '',
          // Named so the rail can target one stable entry point.
          name: 'campaigns_home',
          meta,
          redirect: to => {
            return { name: 'campaigns_index', params: to.params };
          },
        },
        {
          path: 'all',
          name: 'campaigns_index',
          meta,
          component: AllCampaignsPage,
        },
        {
          // The sidebar's channel entries: the same unified dashboard scoped
          // to one channel, so a channel view is a real URL rather than a
          // filter chip that vanishes on reload.
          path: 'all/:channel',
          name: 'campaigns_channel_index',
          meta,
          component: AllCampaignsPage,
        },
        {
          path: ':displayId/edit',
          name: 'campaigns_builder',
          meta,
          component: CampaignBuilderPage,
        },
        // Legacy campaign URLs (pre unified dashboard) land on the new index.
        ...['ongoing', 'one_off', 'live_chat', 'sms', 'whatsapp'].map(path => ({
          path,
          meta,
          redirect: to => ({ name: 'campaigns_index', params: to.params }),
        })),
      ],
    },
  ],
};

export default campaignsRoutes;
